module.exports = __webpack_public_path__ + "static/media/ar.85592324.svg";